import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddCategoryPageNew from "../../components/Category/AddCategoryPageNew";



const AddCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Category" link2="/category" title="Add Category" />

        {/* AddUserLayer */}
        <AddCategoryPageNew />


      </MasterLayout>
    </>
  );
};

export default AddCategoryPage;
